<script context="module">
    export let newsletterSignupNumber = 0;
</script>

<script>
    newsletterSignupNumber += 1;
</script>
